<script>
export default {
  functional: true,
  props: {
    row: Object,
    render: Function
  },
  render: (h, data) => {
    const params = {
      row: data.props.row,
      index: data.props.index
    }
    return data.props.render(h, params);
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Table/myRender.vue